class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => this.onAccordionClick(event));
  }

  onAccordionClick(event) {
    const trigger = event.target.closest('.accordion__trigger, h4');
    if (!trigger || !this.contains(trigger)) return;

    const isOpen = trigger.classList.contains('open');
    this.closeAll();

    if (!isOpen) {
      this.openTrigger(trigger);
    }
  }

  closeAll() {
    this.querySelectorAll('.accordion__trigger.open, h4.open').forEach((el) => {
      el.classList.remove('open');
      el.setAttribute('aria-expanded', 'false');
      const content = el.nextElementSibling;
      if (content && content.classList.contains('accordion-content')) {
        content.setAttribute('aria-hidden', 'true');
      }
    });
  }

  openTrigger(trigger) {
    trigger.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
    const content = trigger.nextElementSibling;
    if (content && content.classList.contains('accordion-content')) {
      content.setAttribute('aria-hidden', 'false');
    }
  }
}

customElements.define('accordion-component', AccordionComponent);
